export const COMPANYDECLAREPROPOSALLIST_SEARCH = 'COMPANYDECLAREPROPOSALLIST_SEARCH';
export const COMPANYDECLAREPROPOSALLIST_PAGE = 'COMPANYDECLAREPROPOSALLIST_PAGE';
export const COMPANYDECLAREPROPOSALLIST_SORTBY = 'COMPANYDECLAREPROPOSALLIST_SORTBY';
